module.exports = __webpack_public_path__ + "static/media/externalCourse.28ecb06e.svg";